export default __webpack_public_path__ + "static/media/auditReport.7d539de2.svg";